import React from 'react';
import 'twin.macro';
import { TitleWithEditButton } from '@teetsh/app/src/components/TitleWithEditButton';
import { useOpenUpdateFolderTitleModal } from './atom';

interface Props {
  id: string;
  title?: string;
  onChange?: (newTitle: string) => void;
}

export function InlineEditableTitle({ id, title, onChange }: Props) {
  const openModal = useOpenUpdateFolderTitleModal();

  if (!onChange) {
    return <h1 tw="mb-6 font-black text-center">{title}</h1>;
  }

  return (
    <div tw="mb-6 flex justify-center">
      <TitleWithEditButton
        title={title || ''}
        onEdit={() =>
          openModal({
            id,
            title: title || '',
            onSave: onChange,
          })
        }
      />
    </div>
  );
}
